import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import 'semantic-ui-css/semantic.min.css';
import './styles/index.css';
import { StreamProvider } from './interlucent/StreamContext';
var container = document.getElementById('root');
var root = createRoot(container);
root.render(_jsx(Router, { children: _jsx(StreamProvider, { children: _jsx(App, {}) }) }));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
